module.exports = __webpack_public_path__ + "img/pin_blue.d002aaec.svg";